<template>
	<div style="text-align: center">
		<md-card class="md-elevation-1">
			<md-card-header>
				<div class="title">
					<p>403</p>
					<p>Forbidden</p>
				</div>
				<p>
					Contact you administrator for permission!
				</p>
				<p>
					<a :href="loginUrl">Return to Login</a>
				</p>
			</md-card-header>
			<md-card-content>
			</md-card-content>
		</md-card>
	</div>
</template>

<script>
import config from '../../config'
export default {
	name: 'Forbidden',
	data: function() {
		return {
			loginUrl: config.AUTH_URL
		}
	}
}
</script>

<style scoped>
.md-card {
	width: 400px;
	height: 400px;
	margin-top: 100px;
	display: inline-block;
	vertical-align: top;
}
.title {
	margin-top: 100px;
	font-size: 50px;
}
</style>